import core from "@/helpers/client";
const serviceService = {
  async headServiceAsync(applicationId, params) {
    const result = await core.head(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/services?no-cache=1`,
      params
    );
    return result;
  },
  async getServicesAsync(applicationId, params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/services?no-cache=1`,
      params
    );
    return result;
  },
  async getServiceAsync(applicationId, id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/services/${id}?no-cache=1`
    );
    return result;
  },
  async createServiceAsync(applicationId, model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/services`,
      model
    );
    return result;
  },
  async updateServiceAsync(applicationId, id, model) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/services/${id}`,
      model
    );
    return result;
  },
  async deleteServiceAsync(applicationId, id) {
    const result = await core.delete(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/services/${id}`
    );
    return result;
  },
  async getServiceParametorOptionsAsync(id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/services/${id}/ParametorOptions?no-cache=1`
    );
    return result;
  },
  async getApplicationServiceParameterOptionsAsync(applicationId) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/Services/ParameterOptions?no-cache=1`
    );
    return result;
  }, 
};
export default serviceService;
